export default __webpack_public_path__ + "defbd862ed2488124f1b029228ae6848.png";